import { put } from 'redux-saga/effects'
import { getAllIcd, icdSearch} from '../../Services'

export function* getIcdAllSaga(action) {
    const payload = action.payload
    try {
        const res = yield getAllIcd(payload)
        yield put({ type: 'REQ_ICD_ALL_SUCCEEDED', data: res.data })
    }

    catch (e) {
        yield put({ type: 'REQ_ICD_ALL_FAILED', errData: e})
    }

}

export function* icdSearchSaga (action) {
    const payload = action.payload
    try {
        const res = yield icdSearch(payload)
        yield put({type: 'REQ_ICD_SEARCH_SUCCEEDED', data: res.data})
    } 

    catch (e) {
        yield put({ type: 'REQ_ICD_SEARCH_FAILED', errData: e})
    }
}